// =============================================
// MusicCover — small album-art thumbnail
// =============================================
// Resolves a track's cover blob from IndexedDB to an object URL (revoked on change/
// unmount) and renders it; falls back to a gradient + music-note placeholder when the
// track has no cover. Reused in library rows, playlist rows, and the mini-bar.
// =============================================
import React, { useEffect, useState } from 'react';
import { FiMusic } from 'react-icons/fi';
import { getAudioUrl } from '../../lib/audioStore';

interface Props {
  coverKey: string | null;
  size?: number;
  className?: string;
}

export const MusicCover: React.FC<Props> = ({ coverKey, size = 38, className }) => {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    let u: string | null = null;
    setUrl(null);
    if (coverKey) {
      getAudioUrl(coverKey).then(r => {
        if (cancelled) { if (r) URL.revokeObjectURL(r); return; }
        u = r; setUrl(r);
      });
    }
    return () => { cancelled = true; if (u) URL.revokeObjectURL(u); };
  }, [coverKey]);

  return (
    <span className={`mcov ${className || ''}`} style={{ width: size, height: size }}>
      {url ? <img src={url} alt="cover" /> : <FiMusic />}
    </span>
  );
};

export default MusicCover;
